export enum EffectivenessQuestionResponseValues {
  veryLow = 0,
  low = 1,
  moderate = 2,
  high = 3,
  veryHigh = 4
}
